document.addEventListener('DOMContentLoaded', function () {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  function initMegaHover() {
    const megaMenus = document.querySelectorAll('details.mega-menu--tiles');

    megaMenus.forEach((menu) => {
      let timeout;

      menu.addEventListener('mouseenter', () => {
        if (!desktopMedia.matches) return;
        clearTimeout(timeout);
        menu.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktopMedia.matches) return;
        timeout = setTimeout(() => {
          menu.removeAttribute('open');
        }, 120);
      });
    });
  }

  initMegaHover();
});
